import {IconWithLabel} from '@hconnect/common/components/shiftEventLabels'
import {StatusWithNoneAndCancellationAndApproverAndWorkOrderStates} from '@hconnect/common/types'
import {Block, Done, Remove, Loop, HourglassEmpty, Check, CancelOutlined} from '@mui/icons-material'
import {SvgIcon, SxProps, Theme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {SapIcon} from '../assets'
import {COMMON_SHIFT_EVENT_WIDGET_NAMESPACE} from '../consts'

export const eventStatusIcons: Record<
  StatusWithNoneAndCancellationAndApproverAndWorkOrderStates,
  React.ReactElement
> = {
  pending: <HourglassEmpty sx={{color: 'error.main'}} />,
  ongoing: <Loop sx={{color: 'secondary.main'}} />,
  done: <Done sx={{color: 'success.main'}} />,
  cancelled: <Block sx={{color: 'secondary.main'}} />,
  none: <Remove />,
  approved: <Check sx={{color: 'success.main'}} />,
  rejected: <CancelOutlined sx={{color: 'error.main'}} />,
  waitingForApproval: <HourglassEmpty />,
  workOrderCreated: <SvgIcon component={SapIcon} />,
  implemented: <Done sx={{color: 'success.main'}} />,
  implementedTemporary: <Done sx={{color: 'success.main'}} />,
  reverted: <Loop sx={{color: 'secondary.main'}} />
}

export const eventStatusContrastIcons: Record<
  StatusWithNoneAndCancellationAndApproverAndWorkOrderStates,
  React.ReactElement
> = {
  pending: <HourglassEmpty sx={{color: 'error.light'}} />,
  ongoing: <Loop sx={{color: 'secondary.light'}} />,
  done: <Done sx={{color: 'success.light'}} />,
  cancelled: <Block sx={{color: 'secondary.light'}} />,
  none: <Remove sx={{color: 'secondary.light'}} />,
  approved: <Check sx={{color: 'success.light'}} />,
  rejected: <CancelOutlined sx={{color: 'error.light'}} />,
  waitingForApproval: <HourglassEmpty sx={{color: 'secondary.light'}} />,
  workOrderCreated: <SvgIcon component={SapIcon} />,
  implemented: <Done sx={{color: 'success.light'}} />,
  implementedTemporary: <Done sx={{color: 'success.light'}} />,
  reverted: <Loop sx={{color: 'secondary.light'}} />
}

export const EventStatusLabel: React.FC<{
  status: StatusWithNoneAndCancellationAndApproverAndWorkOrderStates
  iconOnly?: boolean
  sx?: SxProps<Theme>
}> = (props) => {
  const {t} = useTranslation(COMMON_SHIFT_EVENT_WIDGET_NAMESPACE)

  return (
    <StatusLabel
      status={props.status}
      sx={props.sx}
      iconOnly={props.iconOnly}
      label={t(`shiftEvent.status.${props.status}`)}
    />
  )
}

export const StatusLabel: React.FC<{
  status: StatusWithNoneAndCancellationAndApproverAndWorkOrderStates
  label: string
  iconOnly?: boolean
  sx?: SxProps<Theme>
}> = (props) => {
  return (
    <IconWithLabel
      sx={props.sx}
      icon={eventStatusIcons[props.status] ?? <Remove />}
      iconOnly={props.iconOnly}
      label={props.label}
    />
  )
}
